import { Save } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';
import { useColors } from '../../../../Context/ColorsContext';
import { MediaQuerys } from '../../../../styles/GlobalStyle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { IconButton, TableCell, Button } from "@mui/material";
import TableBody from '@mui/material/TableBody';
import Toolbar from '@mui/material/Toolbar';
import ShowChartIcon from '@mui/icons-material/ShowChart';


const { mobile, tablet, desktop } = MediaQuerys;


export const Cell = styled(TableCell)(() => ({
    border: 'none'
}))

export const IconAction = styled(IconButton)(() => {
    const { colors } = useColors();
    return {
        borderRadius: 20,
        pointerEvents: "pointer",
        background: colors.buttonActionColor,
        marginLeft: 5,
        "&:hover": {
            backgroundColor: colors.buttonActionColor,
            opacity: 0.9,
            color: colors.white,
        },
        [desktop]: {
            fontSize: "0.25rem",
            width: '28px',
            height: '28px',
            "&MuiSvgIcon-root": {
                width: '16px'
            }
        },
        [tablet]: {
            height: 28,
            width: 28,
        },
        [mobile]: {
            display: 'none',
        },
    };
});

export const NewIcon = styled(AddCircleIcon)(() => {
    const { colors } = useColors();
    return {
        height: '20px',
        width: '20px',
        color: colors.white,
        // fontSize: 18,
        [desktop]: {
            height: '16px',
            width: '16px'
        }
    };
});


export const IconContainer = styled(IconButton)(() => {
    const { colors } = useColors();
    return {
      borderRadius: '10%',
      backgroundColor: colors.background,
      color: colors.buttonActionColor,
      "&:hover": {
        backgroundColor: colors.buttonActionColor,
        color: colors.white,
      }
    }
  })
  
  export const TableContent = styled(TableBody)(() => ({
    overflow: 'auto',
    ".MuiTableCell-root": {
      fontSize: "1rem !important",
      [desktop]: {
        fontSize: "0.75rem !important",
      },
      [mobile]: {
        fontSize: "0.70rem !important",
      },
    },
    [tablet]: {
      '.MuiTablePagination-displayedRows': {
        fontSize: '0.75rem !important',
      },
      '.MuiTablePagination-selectLabel':{
        fontSize: '0.75rem!important',
      }
    },
  }));

  export const CustomSave = styled(Save)(() => {
    return {
      [desktop]: {
        width: '16px',
        height: '16px',
      }
    }
  })

  export const ContainerContent = styled('div')(() => {
    return {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '15px',
    }
  })
  
  
  export const ContainerSaveButton = styled('div')(() => {
    return {
      display: 'flex',
      [mobile]: {
        width: '100%',
        height: '100%',
        justifyContent: 'flex-end',
      }
    }
  })


  export const GroupActions = styled('div')(() => {
    return {
      display: 'flex',
      flexDirection: 'row',
      gap: '0.50rem'
    }
  })
  
  export const CustomToolbar = styled(Toolbar)(() => {
    const { colors } = useColors();
    return {
      justifyContent: 'end',
      background: colors.gray,
      borderRadius: "5px 5px 0 0",
      minHeight: "50px !important",
      [mobile]: {
        minHeight: "auto !important",
        padding: "5px 5px",
      },
      [tablet]: {
        minHeight: "40px !important",
      },
    }
  })

  export const ButtonForm = styled(Button)(() => {
    const { colors } = useColors();   
    return {
      height: '100%',
      width: '100%',
      padding: "0 20px",
      backgroundColor: colors.buttonActionColor,
      color: colors.white,
      "&:hover": {
        backgroundColor: colors.buttonActionColor,
        opacity: 0.9,
        color: colors.white
      }
    }
  })

  export const ContainerBtnGraph = styled('div')(() => {
    const { colors } = useColors();
    return {
      display: 'flex',
      justifyContent: 'center',
      border: `2px solid ${colors.buttonActionColor}`,
      borderRadius: "5px",
      alignItems: 'center',
      height: 30,
      width: 40,
    }
  })

  export const CustomShowChartIcon = styled(ShowChartIcon)(() => {
    const { colors } = useColors();
    return {
      color: colors.buttonActionColor,
    }
  })

  export const ContainerGroup = styled('div')(() => {
    return {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'row',
        gap: '0.75rem'
    }
  })

  export const IconArea = styled('div')(() => {
    const { colors } = useColors();
    return {
        width: 15,
        height: 15,
        fontSize: 10,
        fontWeight: 'bold',
        color: colors.white,
        background: colors.buttonActionColor,
        borderRadius: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'auto',
        [desktop]: {
            height: 15,
            width: 15
        }
    }
  })